import React, { useState, useRef, useEffect, Fragment } from 'react';
import { Typography, Fab, makeStyles, Theme, createStyles, LinearProgress, Grid } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import VisibilityIcon from '@material-ui/icons/Visibility';
import BackIcon from '@material-ui/icons/ArrowBack';
import DeleteIcon from '@material-ui/icons/Delete';
import Constants from '../../types/constants';
import { InEditingMode, IGlobalState, InEditingType } from '../../states/GlobalState';
// import EditUserModeRead from './EditUserModeRead';
import PrincipalFields from './fields';
import { useGlobal, useDispatch } from 'reactn';
import apiService from '../../services/api'
import { useHistory, useLocation } from 'react-router-dom';
import {CustomDialog} from '../../dialog/CustomDialog';
import { Principal } from '../../models/principal';
import ConfirmDialog from '../../dialog/ConfirmDialog';
import { LoggerServiceProvider, useLogger } from '../../logger';
import { deletePrincipal } from '../../services/principalService';
import PrincipalAuthList from '../../views/principalAuth/index';
import { getIdentityFromStorage } from '../../types/auth';

const contentMaxWidth = Constants.PageEditPrincipalContentMaxWidth;
const useStyles = makeStyles((theme: Theme) => createStyles({
    locked: {
        color: theme.palette.error.main,
        marginLeft: theme.spacing(2),
    },
    principalheader: {
        display: 'flex',
        maxWidth: contentMaxWidth,
        flex: '0 0 36px',
        float: 'right'
    },
    containerMain: {
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        paddingTop: '8px',
        flex: '0 1 auto'        
    },
    fab: {
        marginLeft: theme.spacing(1),
    },
}))

type EditPrincipalPropsType = {
    initialMode: InEditingMode,
}

export default function PrincipalEdit({initialMode}: EditPrincipalPropsType) {
    const submitFunctionRef = useRef<() => Promise<any>>(); //Referenza ad una funzione
    const refreshFunctionRef = useRef<() => void>() //Referenza ad una funzione
    const dispatch = useDispatch()
    const [currentEditPrincipal,] = useGlobal<IGlobalState, 'currentEditPrincipal'>('currentEditPrincipal')
    // const [newUserNextOid] = useGlobal<IGlobalState, 'newUserNextOid'>('newUserNextOid')
    const [, setCurrentEditStatus] = useGlobal<IGlobalState, 'currentEditPrincipalStatus'>('currentEditPrincipalStatus')
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
    const [/*confirmCloneDialogOpen*/, setConfirmCloneDialogOpen] = useState(false);
    const [working, setWorking] = useState(false)
    const principalEdit = currentEditPrincipal; 
    // const { adOwnerContext, adLevels } = useAuthDataContext();
    const [auth] = useGlobal<IGlobalState, 'auth'>('auth');
    const [ip] = useGlobal<IGlobalState, 'ip'>('ip');
    const [identity] = useGlobal<IGlobalState, 'identity'>('identity');
    const history = useHistory();
    // const location = useLocation();
    const classes = useStyles();
    const logger = useLogger({key: 'principal'});

    // useEffect(() => {
    //     // Controlliamo se è cambiato l'oid del pathname rispetto all'oid di inedituser
    //     if(currentEditPrincipal) {
    //         console.log('Sono in edit con current Edit');
    //         console.log('Principal id for current is: ' + currentEditPrincipal.principal.Id);
    //         if(urloid === currentEditPrincipal.principal.Id && urloid <= 0) 
    //             setEditMode(InEditingMode.New)
    //         else {
    //             setEditMode(InEditingMode.Edit);
    //         }
    //     }
    //     // TODO
    //     // UserService.clearCache()
    // }, [location, urloid, currentEditPrincipal])
    //Definisco la callback alla submit
    const handleSetSubmitCallback = (callback: () => Promise<any>) => submitFunctionRef.current = callback;
    const handleSetRefreshCallback = (callback: () => void) => refreshFunctionRef.current = callback;

    // const handleMode = (newmode: InEditingMode) => {
    //     const inedit: InEditingType | null = currentEditPrincipal
    //     if (inedit) {
    //         if (inedit.mode === InEditingMode.Edit && newmode === InEditingMode.Read && submitFunctionRef.current) {
    //             submitFunctionRef.current().then(() => {
    //                 setEditMode(inedit.mode)
    //             })
    //         } else {
    //             inedit.mode = newmode;
    //             setEditMode(newmode);
    //         }
    //     }
    // }
    const handleSubmit = () => {
        console.log('*** *** *** SUBMIT END *** *** ***');
        // currentEditPrincipal /*&& setEditMode(currentEditPrincipal.mode)*/;
    }

    /* Cancellazione */
    const doDelete = (item: Principal) => {
        deletePrincipal(ip, auth.authData!, auth.user!, item.Id).then(result => {
            setWorking(true);
            console.log('Deleted principal', result)
            if(result === false) {
                logger.error(`Errore nella cancellazione ${item.Id} [${result}]`);
            } else if(result === true) {
                logger.info(`Cancellazione ${item.Id} riuscita [${result}]`);
            }
            return dispatch.removeInEditPrincipal(item.Id);
        }).finally(() => { 
            setWorking(false) 
            history.replace('/principal')
        });
    }
    
    const handleDelete = () => {
        console.log('*** +++ handleDelete')
        if(currentEditPrincipal) {
            setConfirmDialogOpen(true)
        }
    }
    // const handleClone = () => {
    //     console.log('*** +++ handleClone')
    //     if(currentEditPrincipal) {
    //         setConfirmCloneDialogOpen(true)
    //     }
    // }
    // const handleRefresh = () => {
    //     console.log('*** +++ handleRefresh')
    //     refreshFunctionRef.current && refreshFunctionRef.current();
    //     // TODO
    //     console.log('lo stato diventa pristine');
    //     setCurrentEditStatus('Pristine');
    // }

    const handleBack = () => {
        history.push('/principal');
    }

    const handleSaveNew = () => {
        if(submitFunctionRef.current) {
            console.log('Sto per eseguire la current che è la submitform di Formik');
            submitFunctionRef.current();
        }
    }
    const closeConfirmDialog = (event: {}) => setConfirmDialogOpen(false)
    const closeConfirmCloneDialog = (event: {}) => setConfirmCloneDialogOpen(false)

    const confirmDelete = (context?: any) => {
        setConfirmDialogOpen(false)
        // TODO
        currentEditPrincipal && doDelete(currentEditPrincipal.principal);
    }
    
    return (
        <React.Fragment>
            <div className={classes.containerMain}>
            <div className={classes.principalheader}>
                {/* <Typography variant='h5'>
                    {principalEdit.principal.Id > 0 ? (<small><small><em>({principalEdit.principal.Id > 0 ? principalEdit.principal.Id : 'NUOVO'})</em></small></small>) : null}
                </Typography> */}
                <div style={{ flex: '1 1' }}>&nbsp;</div>
                <div style={{ flex: '0 0' }}>
                    <Fab color='primary' size='small' className={classes.fab} 
                        onClick={(event) => handleBack()} title='Indietro'><BackIcon /></Fab>
                </div>
                <div style={{ flex: '0 0' }}>
                    <Fab color='secondary' size='small' className={classes.fab} style={{backgroundColor: 'rgba(0, 161, 216, 1.0)' }} 
                        onClick={(event) => handleSaveNew()} title='SALVA Modifiche'><SaveIcon /></Fab>
                </div>
                <div style={{ flex: '0 0' }}>
                    {currentEditPrincipal?.mode !== InEditingMode.New && currentEditPrincipal?.principal.Id !== identity?.Id ? 
                    (<Fab color='default' size='small' className={classes.fab} 
                        onClick={(event) => handleDelete()} title='Elimina Utente'><DeleteIcon /></Fab>) : null}
                </div>
            </div>
            {/* here is starting the part of resume Principal */}
            {currentEditPrincipal ? (
                <>
                    <EditFields
                        setSubmitCallback={handleSetSubmitCallback} 
                        setRefreshCallback={handleSetRefreshCallback} 
                        onSubmit={handleSubmit} />
                    {currentEditPrincipal.principal && currentEditPrincipal.principal.Id > 0 ?    
                        <PrincipalAuthList principal={currentEditPrincipal.principal}/>
                    : null}
                </>
                ) :
                <div></div>
            }
            </div>
            {working && <LinearProgress color='primary' />}
            <ConfirmDialog open={confirmDialogOpen} cancel={closeConfirmDialog} confirm={confirmDelete} 
                title={'Cancellazione Utente'} 
                prompt={"Cancello l\'utente?"}>
                <Fragment>
                    <Typography variant='body1'>{'Utente'} <strong>{principalEdit && principalEdit.principal ? principalEdit.principal.Name + ' ' + principalEdit.principal.Surname : ''}</strong></Typography>
                    <p></p>
                </Fragment>
            </ConfirmDialog>
        </React.Fragment>
    );
};

type PrincipalFieldsPropsType = {
    onLockedChange?: (isLocked: boolean) => void,
    onModifiedChange?: (isModified: boolean) => void,
    setSubmitCallback?: (callback: () => Promise<any>) => void,
    setRefreshCallback?: (callback: () => void) => void,
    onSubmit?: () => void
}
const EditFields = ({setSubmitCallback, setRefreshCallback, onSubmit}: PrincipalFieldsPropsType) => {
    return (
        <PrincipalFields setSubmitCallback={setSubmitCallback} setRefreshCallback={setRefreshCallback} onSubmit={onSubmit} />
    )
}

